module.exports = __webpack_public_path__ + "img/cog-double-3.c74dbc22.svg";